import React, { useState } from "react";
import PropTypes from "prop-types";
import { useUserRole } from "hooks/useRoleCheck";
import WebHookAdd from "./Add";
import style from "./style.module.css";
import WebHook from "./WebHook";

const WebHooks = ({ environment = {} }) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [newSigningKey, setNewSigningKey] = useState(null);
  const [newWebHookId, setNewWebHookId] = useState(null);

  const isUser = useUserRole();

  const handleAddWebHook = (newWebHook) => {
    setShowAddForm(false);

    if (newWebHook) {
      setNewSigningKey(newWebHook.signingKey);
      setNewWebHookId(newWebHook.webHook.id);
    }
  };

  return (
    <React.Fragment>
      <h4>Web Hooks</h4>
      {environment.webHooks?.map((webHook) => (
        <WebHook
          key={webHook.id}
          webHook={webHook}
          environment={environment}
          newSigningKey={newSigningKey}
          newWebHookId={newWebHookId}
        />
      ))}

      {showAddForm ? (
        <WebHookAdd environmentId={environment.id} onClose={handleAddWebHook} />
      ) : (
        isUser && (
          <div onClick={() => setShowAddForm(true)} className={style.add}>
            <i className="material-icons">add</i>
            <span data-cy="add-web-hook-btn">Add Web Hook</span>
          </div>
        )
      )}
    </React.Fragment>
  );
};

WebHooks.propTypes = {
  environment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    webHooks: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default WebHooks;
